// Traduções do módulo de Pendências (14/10/2026). Coletadas por glob em
// core/i18n/messages.ts.
export default {
  pt: {
    'pendencias.title': 'Pendências',
    'pendencias.eyebrow': 'Logística',
    'pendencias.filtro.dupla': 'Dupla',
    'pendencias.filtro.modulo': 'Módulo',
    'pendencias.filtro.cliente': 'Cliente',
    'pendencias.filtro.contrato': 'Contrato',
    'pendencias.filtro.busca': 'Buscar',
    'pendencias.filtro.buscar': 'Buscar',
    'pendencias.filtro.todas': 'Todas',
    'pendencias.filtro.todos': 'Todos',
    'pendencias.filtro.limpar': 'Limpar',
    'pendencias.filtro.semDupla': 'Não registrada',
    'pendencias.modulo.frente_trabalho': 'Frente de Trabalho',
    'pendencias.modulo.transporte_maquina': 'Transporte Máquina',
    'pendencias.modulo.outros_servicos_transporte': 'Outros Serviços Transporte',
    'pendencias.tipo.contrato_sem_vinculo_protheus': 'Contrato sem vínculo com o Protheus',
    'pendencias.tipo.viagem_sem_equiparacao_frente': 'Viagem sem equiparação na Frente',
    'pendencias.tipo.viagem_sem_equiparacao_transporte_maquina': 'Viagem sem equiparação no Transporte Máquina',
    'pendencias.tipo.viagem_sem_equiparacao_outros_servicos': 'Viagem sem equiparação em Outros Serviços',
    'pendencias.tipo.viagem_outros_sem_classificacao': 'Viagem Outros sem classificação',
    'pendencias.tipo.maquinario_sem_equiparacao': 'Maquinário sem equiparação',
    'pendencias.tipo.viagem_sem_nf_solicitada': 'Viagem sem nota fiscal solicitada',
    'pendencias.tipo.anomalia': 'Anomalia',
    'pendencias.tipo.maquinario_sem_frota_leve': 'Maquinário sem frota leve',
    'pendencias.tipo.maquinario_sem_hospedagem': 'Maquinário sem hospedagem',
    'pendencias.tipo.apontamento_pendente_transporte_maquina': 'Apontamento pendente no Transporte Máquina',
    'pendencias.tipo.data_viagem_prancha_diferente': 'Data viagem prancha diferente',
    'pendencias.tipo.colheita_pendente_lancamento': 'Colheita pendente de lançamento',
    'pendencias.detalhe.cargasProgramadas_one': '{{count}} carga programada',
    'pendencias.detalhe.cargasProgramadas_other': '{{count}} cargas programadas',
    'pendencias.todasDica': 'Todas as pendências abertas no recorte. Clique num cartão para ver só aquele tipo, e em mais de um para juntar.',
    'pendencias.regra.ondeCorrigir': 'Onde corrigir',
    'pendencias.regra.contrato_sem_vinculo_protheus': 'Contrato da Frente de Trabalho que já tem carga, linha de maquinário ou programação de colheita lançada e ainda não foi vinculado a uma frente do Protheus no cabeçalho.',
    'pendencias.regra.viagem_sem_equiparacao_frente': 'Carga da Frente com motorista e cavalo, de {{piso}} em diante e fora de Não atendido, que ainda não foi equiparada a uma viagem do Protheus.',
    'pendencias.regra.viagem_sem_equiparacao_transporte_maquina': 'Viagem de prancha do Transporte Máquina com cavalo, de {{piso}} em diante, sem viagem do Protheus vinculada. A viagem em Previsto, que espera a predecessora, e a máquina que foi rodando não entram.',
    'pendencias.regra.viagem_sem_equiparacao_outros_servicos': 'Linha de Outros Serviços com conjunto escalado, de {{piso}} em diante e fora de Não atendido, sem viagem do Protheus vinculada.',
    'pendencias.regra.viagem_outros_sem_classificacao': 'Linha de Outros Serviços de {{piso}} em diante cuja viagem do Protheus está em Outros, no serviço padrão ou sem serviço, e ainda não recebeu o Serviço HUB. A Diária não entra.',
    'pendencias.regra.maquinario_sem_equiparacao': 'Linha do Maquinário com máquina ou operador, de {{piso}} em diante, que ainda não foi equiparada a uma linha da frente do Protheus.',
    'pendencias.regra.viagem_sem_nf_solicitada': 'Carga equiparada em Trânsito, Descarregando ou Atendido, de {{piso}} em diante, cuja viagem do Protheus ainda não tem nota fiscal com data de solicitação.',
    'pendencias.regra.anomalia': 'O HUB e o Protheus discordam. No cabeçalho da Frente, o pedágio ou os hectares. Na carga equiparada, o motorista, o cavalo ou a carreta, até alguém aprovar a diferença. Em Outros Serviços, o motorista, o cavalo, as carretas ou o cliente do Protheus sem Cliente HUB.',
    'pendencias.regra.maquinario_sem_frota_leve': 'Contrato não finalizado, com maquinário lançado, em que nenhum operador tem um utilitário ativo em Conjuntos.',
    'pendencias.regra.maquinario_sem_hospedagem': 'Contrato não finalizado com operador do Maquinário sem hospedagem em aberto. A linha lista quem está sem.',
    'pendencias.regra.apontamento_pendente_transporte_maquina': 'Viagem de prancha em Finalizado que ainda não foi marcada como Apontada. A máquina que foi rodando não entra.',
    'pendencias.regra.data_viagem_prancha_diferente': 'A Data Ini ou a Data Fim da viagem de prancha no HUB é diferente da saída ou da chegada da viagem vinculada no Protheus. Só compara a data preenchida dos dois lados.',
    'pendencias.regra.maquinario_sem_medicao': 'Linha do Maquinário equiparada, de {{piso}} em diante, com a frente Finalizada ou Finalizada com pendência, cuja linha no Protheus ainda não tem medição.',
    'pendencias.regra.colheita_pendente_lancamento': 'Programação de colheita de dia passado, de {{piso}} em diante, sem as cargas atendidas lançadas na Frente. Zero lançado conta como lançamento.',
    'pendencias.tipo.maquinario_sem_medicao': 'Maquinário sem medição',
    'pendencias.col.tipo': 'Pendência',
    'pendencias.col.registro': 'Registro',
    'pendencias.col.cliente': 'Cliente',
    'pendencias.col.contrato': 'Contrato',
    'pendencias.col.data': 'Data',
    'pendencias.col.ha': 'Há',
    'pendencias.col.detalhe': 'Detalhe',
    'pendencias.frente': 'Frente {{frente}}',
    'pendencias.todas': 'Todas',
    'pendencias.atualizado': 'Atualizado em',
    'pendencias.indisponiveis': 'Não foi possível calcular agora estas pendências. As demais estão na lista.',
    'pendencias.vazio': 'Nenhuma pendência neste recorte.',
    'pendencias.abrir': 'Abrir',
    'pendencias.aprovar': 'Aprovar',
    'pendencias.aprovada': 'Divergência aprovada.',
    'pendencias.aprovarTitulo': 'Aprovar a divergência de conjunto',
    'pendencias.aprovarMensagem': 'A composição da carga {{carga}} fica aceita como está, diferente da viagem do Protheus. Uma diferença nova volta a aparecer.',
    'pendencias.corrigirEm.clientesHub': 'Clientes HUB',
    'pendencias.corrigirEm.utilitarios': 'Utilitários',
    'pendencias.corrigirEm.hospedagem': 'Hospedagem',
    'pendencias.registro.linhaOutros': 'Linha de Outros Serviços',
    'pendencias.registro.maquinario': 'Linha de maquinário',
    'pendencias.registro.contrato': 'Contrato',
    'pendencias.detalhe.hub': 'HUB',
    'pendencias.detalhe.protheus': 'Protheus',
    'pendencias.detalhe.semHospedagem_one': '{{count}} operador sem hospedagem',
    'pendencias.detalhe.semHospedagem_other': '{{count}} operadores sem hospedagem',
    'pendencias.detalhe.viagens': 'Viagens',
    'pendencias.detalhe.maquinarios': 'Maquinários',
    'pendencias.detalhe.colheitas': 'Colheitas',
    'pendencias.detalhe.semServico': 'Sem serviço',
    'pendencias.campo.motorista': 'Motorista',
    'pendencias.campo.cavalo': 'Cavalo',
    'pendencias.campo.carreta': 'Carreta',
    'pendencias.campo.cliente': 'Cliente sem Cliente HUB',
    'pendencias.campo.pedagio': 'Pedágio',
    'pendencias.campo.hectares': 'Hectares',
    'pendencias.campo.data_inicio': 'Data de início',
    'pendencias.campo.data_fim': 'Data de fim',
    'pendencias.etapa.escalado': 'Escalado',
    'pendencias.etapa.carregando': 'Carregando',
    'pendencias.etapa.transito': 'Trânsito',
    'pendencias.etapa.descarregando': 'Descarregando',
    'pendencias.etapa.atendido': 'Atendido',
    'pendencias.etapa.nao_atendido': 'Não atendido',
  },
  en: {
    'pendencias.title': 'Pending items',
    'pendencias.eyebrow': 'Logistics',
    'pendencias.filtro.dupla': 'Pair',
    'pendencias.filtro.modulo': 'Module',
    'pendencias.filtro.cliente': 'Customer',
    'pendencias.filtro.contrato': 'Contract',
    'pendencias.filtro.busca': 'Search',
    'pendencias.filtro.buscar': 'Search',
    'pendencias.filtro.todas': 'All',
    'pendencias.filtro.todos': 'All',
    'pendencias.filtro.limpar': 'Clear',
    'pendencias.filtro.semDupla': 'Not registered',
    'pendencias.modulo.frente_trabalho': 'Work Front',
    'pendencias.modulo.transporte_maquina': 'Machine Transport',
    'pendencias.modulo.outros_servicos_transporte': 'Other Transport Services',
    'pendencias.tipo.contrato_sem_vinculo_protheus': 'Contract not linked to Protheus',
    'pendencias.tipo.viagem_sem_equiparacao_frente': 'Trip not matched in the Work Front',
    'pendencias.tipo.viagem_sem_equiparacao_transporte_maquina': 'Trip not matched in Machine Transport',
    'pendencias.tipo.viagem_sem_equiparacao_outros_servicos': 'Trip not matched in Other Services',
    'pendencias.tipo.viagem_outros_sem_classificacao': 'Other trip not classified',
    'pendencias.tipo.maquinario_sem_equiparacao': 'Machinery not matched',
    'pendencias.tipo.viagem_sem_nf_solicitada': 'Trip without invoice request',
    'pendencias.tipo.anomalia': 'Anomaly',
    'pendencias.tipo.maquinario_sem_frota_leve': 'Machinery without light fleet',
    'pendencias.tipo.maquinario_sem_hospedagem': 'Machinery without lodging',
    'pendencias.tipo.apontamento_pendente_transporte_maquina': 'Pending entry in Machine Transport',
    'pendencias.tipo.data_viagem_prancha_diferente': 'Lowboy trip date differs',
    'pendencias.tipo.colheita_pendente_lancamento': 'Harvest awaiting launch',
    'pendencias.detalhe.cargasProgramadas_one': '{{count}} planned load',
    'pendencias.detalhe.cargasProgramadas_other': '{{count}} planned loads',
    'pendencias.todasDica': 'Every open pending item in the current filters. Click a card to see only that type, and more than one to combine them.',
    'pendencias.regra.ondeCorrigir': 'Where to fix',
    'pendencias.regra.contrato_sem_vinculo_protheus': 'Work Front contract that already has a load, a machinery row or a harvest schedule and is not yet linked to a Protheus front in the header.',
    'pendencias.regra.viagem_sem_equiparacao_frente': 'Work Front load with driver and tractor, from {{piso}} on and not in Not served, that is not yet matched to a Protheus trip.',
    'pendencias.regra.viagem_sem_equiparacao_transporte_maquina': 'Machine Transport lowboy trip with a tractor, from {{piso}} on, with no linked Protheus trip. A planned trip, waiting for its predecessor, and a machine that drove on its own are left out.',
    'pendencias.regra.viagem_sem_equiparacao_outros_servicos': 'Other Services row with a scheduled truck set, from {{piso}} on and not in Not served, with no linked Protheus trip.',
    'pendencias.regra.viagem_outros_sem_classificacao': 'Other Services row from {{piso}} on whose Protheus trip is in Other, in the default service or without a service, and has no HUB Service yet. The daily rate is left out.',
    'pendencias.regra.maquinario_sem_equiparacao': 'Machinery row with a machine or an operator, from {{piso}} on, that is not yet matched to a Protheus front row.',
    'pendencias.regra.viagem_sem_nf_solicitada': 'Matched load In transit, Unloading or Served, from {{piso}} on, whose Protheus trip has no invoice with a request date yet.',
    'pendencias.regra.anomalia': 'HUB and Protheus disagree. In the Work Front header, the toll or the hectares. In the matched load, the driver, the tractor or the trailer, until someone approves the difference. In Other Services, the driver, the tractor, the trailers or a Protheus customer without a HUB customer.',
    'pendencias.regra.maquinario_sem_frota_leve': 'Contract not finished, with machinery, where no operator has an active utility vehicle in Sets.',
    'pendencias.regra.maquinario_sem_hospedagem': 'Contract not finished with a Machinery operator without open lodging. The row lists who is missing it.',
    'pendencias.regra.apontamento_pendente_transporte_maquina': 'Lowboy trip in Finished that is not yet marked as Recorded. A machine that drove on its own is left out.',
    'pendencias.regra.data_viagem_prancha_diferente': 'The HUB start or end date of the lowboy trip differs from the departure or arrival of the linked Protheus trip. Only dates filled on both sides are compared.',
    'pendencias.regra.maquinario_sem_medicao': 'Matched Machinery row, from {{piso}} on, with the work front Finished or Finished with pending items, whose Protheus row has no measurement yet.',
    'pendencias.regra.colheita_pendente_lancamento': 'Past harvest schedule, from {{piso}} on, without the attended loads recorded on the Work Front. Zero recorded counts as a record.',
    'pendencias.tipo.maquinario_sem_medicao': 'Machinery without measurement',
    'pendencias.col.tipo': 'Pending item',
    'pendencias.col.registro': 'Record',
    'pendencias.col.cliente': 'Customer',
    'pendencias.col.contrato': 'Contract',
    'pendencias.col.data': 'Date',
    'pendencias.col.ha': 'Age',
    'pendencias.col.detalhe': 'Detail',
    'pendencias.frente': 'Front {{frente}}',
    'pendencias.todas': 'All',
    'pendencias.atualizado': 'Updated at',
    'pendencias.indisponiveis': 'These pending items could not be computed right now. The others are in the list.',
    'pendencias.vazio': 'No pending items for these filters.',
    'pendencias.abrir': 'Open',
    'pendencias.aprovar': 'Approve',
    'pendencias.aprovada': 'Divergence approved.',
    'pendencias.aprovarTitulo': 'Approve the set divergence',
    'pendencias.aprovarMensagem': 'The composition of shipment {{carga}} is accepted as it is, different from the Protheus trip. A new difference shows up again.',
    'pendencias.corrigirEm.clientesHub': 'HUB customers',
    'pendencias.corrigirEm.utilitarios': 'Utility vehicles',
    'pendencias.corrigirEm.hospedagem': 'Lodging',
    'pendencias.registro.linhaOutros': 'Other Services line',
    'pendencias.registro.maquinario': 'Machinery line',
    'pendencias.registro.contrato': 'Contract',
    'pendencias.detalhe.hub': 'HUB',
    'pendencias.detalhe.protheus': 'Protheus',
    'pendencias.detalhe.semHospedagem_one': '{{count}} operator without lodging',
    'pendencias.detalhe.semHospedagem_other': '{{count}} operators without lodging',
    'pendencias.detalhe.viagens': 'Trips',
    'pendencias.detalhe.maquinarios': 'Machinery',
    'pendencias.detalhe.colheitas': 'Harvests',
    'pendencias.detalhe.semServico': 'No service',
    'pendencias.campo.motorista': 'Driver',
    'pendencias.campo.cavalo': 'Tractor',
    'pendencias.campo.carreta': 'Trailer',
    'pendencias.campo.cliente': 'Customer without HUB customer',
    'pendencias.campo.pedagio': 'Toll',
    'pendencias.campo.hectares': 'Hectares',
    'pendencias.campo.data_inicio': 'Start date',
    'pendencias.campo.data_fim': 'End date',
    'pendencias.etapa.escalado': 'Scheduled',
    'pendencias.etapa.carregando': 'Loading',
    'pendencias.etapa.transito': 'In transit',
    'pendencias.etapa.descarregando': 'Unloading',
    'pendencias.etapa.atendido': 'Served',
    'pendencias.etapa.nao_atendido': 'Not served',
  },
  es: {
    'pendencias.title': 'Pendientes',
    'pendencias.eyebrow': 'Logística',
    'pendencias.filtro.dupla': 'Dupla',
    'pendencias.filtro.modulo': 'Módulo',
    'pendencias.filtro.cliente': 'Cliente',
    'pendencias.filtro.contrato': 'Contrato',
    'pendencias.filtro.busca': 'Buscar',
    'pendencias.filtro.buscar': 'Buscar',
    'pendencias.filtro.todas': 'Todas',
    'pendencias.filtro.todos': 'Todos',
    'pendencias.filtro.limpar': 'Limpiar',
    'pendencias.filtro.semDupla': 'No registrada',
    'pendencias.modulo.frente_trabalho': 'Frente de Trabajo',
    'pendencias.modulo.transporte_maquina': 'Transporte de Máquina',
    'pendencias.modulo.outros_servicos_transporte': 'Otros Servicios de Transporte',
    'pendencias.tipo.contrato_sem_vinculo_protheus': 'Contrato sin vínculo con Protheus',
    'pendencias.tipo.viagem_sem_equiparacao_frente': 'Viaje sin equiparación en la Frente',
    'pendencias.tipo.viagem_sem_equiparacao_transporte_maquina': 'Viaje sin equiparación en Transporte de Máquina',
    'pendencias.tipo.viagem_sem_equiparacao_outros_servicos': 'Viaje sin equiparación en Otros Servicios',
    'pendencias.tipo.viagem_outros_sem_classificacao': 'Viaje Otros sin clasificación',
    'pendencias.tipo.maquinario_sem_equiparacao': 'Maquinaria sin equiparación',
    'pendencias.tipo.viagem_sem_nf_solicitada': 'Viaje sin factura solicitada',
    'pendencias.tipo.anomalia': 'Anomalía',
    'pendencias.tipo.maquinario_sem_frota_leve': 'Maquinaria sin flota liviana',
    'pendencias.tipo.maquinario_sem_hospedagem': 'Maquinaria sin hospedaje',
    'pendencias.tipo.apontamento_pendente_transporte_maquina': 'Registro pendiente en Transporte de Máquina',
    'pendencias.tipo.data_viagem_prancha_diferente': 'Fecha de viaje de plataforma diferente',
    'pendencias.tipo.colheita_pendente_lancamento': 'Cosecha pendiente de lanzamiento',
    'pendencias.detalhe.cargasProgramadas_one': '{{count}} carga programada',
    'pendencias.detalhe.cargasProgramadas_other': '{{count}} cargas programadas',
    'pendencias.todasDica': 'Todos los pendientes abiertos en el filtro actual. Haga clic en una tarjeta para ver solo ese tipo, y en más de una para combinarlas.',
    'pendencias.regra.ondeCorrigir': 'Dónde corregir',
    'pendencias.regra.contrato_sem_vinculo_protheus': 'Contrato del Frente de Trabajo que ya tiene carga, línea de maquinaria o programación de cosecha y todavía no fue vinculado a un frente de Protheus en el encabezado.',
    'pendencias.regra.viagem_sem_equiparacao_frente': 'Carga del Frente con conductor y tractor, desde el {{piso}} y fuera de No atendido, que todavía no fue equiparada a un viaje de Protheus.',
    'pendencias.regra.viagem_sem_equiparacao_transporte_maquina': 'Viaje de plataforma de Transporte de Máquina con tractor, desde el {{piso}}, sin viaje de Protheus vinculado. El viaje en Previsto, que espera la predecesora, y la máquina que fue rodando no entran.',
    'pendencias.regra.viagem_sem_equiparacao_outros_servicos': 'Línea de Otros Servicios con conjunto escalado, desde el {{piso}} y fuera de No atendido, sin viaje de Protheus vinculado.',
    'pendencias.regra.viagem_outros_sem_classificacao': 'Línea de Otros Servicios desde el {{piso}} cuyo viaje de Protheus está en Otros, en el servicio estándar o sin servicio, y todavía no recibió el Servicio HUB. La Diaria no entra.',
    'pendencias.regra.maquinario_sem_equiparacao': 'Línea de Maquinaria con máquina u operador, desde el {{piso}}, que todavía no fue equiparada a una línea del frente de Protheus.',
    'pendencias.regra.viagem_sem_nf_solicitada': 'Carga equiparada en Tránsito, Descargando o Atendido, desde el {{piso}}, cuyo viaje de Protheus todavía no tiene factura con fecha de solicitud.',
    'pendencias.regra.anomalia': 'El HUB y Protheus no coinciden. En el encabezado del Frente, el peaje o las hectáreas. En la carga equiparada, el conductor, el tractor o el remolque, hasta que alguien apruebe la diferencia. En Otros Servicios, el conductor, el tractor, los remolques o el cliente de Protheus sin Cliente HUB.',
    'pendencias.regra.maquinario_sem_frota_leve': 'Contrato no finalizado, con maquinaria, en el que ningún operador tiene un utilitario activo en Conjuntos.',
    'pendencias.regra.maquinario_sem_hospedagem': 'Contrato no finalizado con operador de Maquinaria sin hospedaje abierto. La línea lista quién está sin él.',
    'pendencias.regra.apontamento_pendente_transporte_maquina': 'Viaje de plataforma en Finalizado que todavía no fue marcado como Registrado. La máquina que fue rodando no entra.',
    'pendencias.regra.data_viagem_prancha_diferente': 'La fecha de inicio o de fin del viaje de plataforma en el HUB es distinta de la salida o de la llegada del viaje vinculado en Protheus. Solo compara la fecha completada en los dos lados.',
    'pendencias.regra.maquinario_sem_medicao': 'Línea de Maquinaria equiparada, desde el {{piso}}, con el frente Finalizado o Finalizado con pendiente, cuya línea en Protheus todavía no tiene medición.',
    'pendencias.regra.colheita_pendente_lancamento': 'Programación de cosecha de un día pasado, desde el {{piso}}, sin las cargas atendidas registradas en el Frente. Cero registrado cuenta como registro.',
    'pendencias.tipo.maquinario_sem_medicao': 'Maquinaria sin medición',
    'pendencias.col.tipo': 'Pendiente',
    'pendencias.col.registro': 'Registro',
    'pendencias.col.cliente': 'Cliente',
    'pendencias.col.contrato': 'Contrato',
    'pendencias.col.data': 'Fecha',
    'pendencias.col.ha': 'Hace',
    'pendencias.col.detalhe': 'Detalle',
    'pendencias.frente': 'Frente {{frente}}',
    'pendencias.todas': 'Todas',
    'pendencias.atualizado': 'Actualizado el',
    'pendencias.indisponiveis': 'No fue posible calcular ahora estos pendientes. Los demás están en la lista.',
    'pendencias.vazio': 'Ningún pendiente en este recorte.',
    'pendencias.abrir': 'Abrir',
    'pendencias.aprovar': 'Aprobar',
    'pendencias.aprovada': 'Divergencia aprobada.',
    'pendencias.aprovarTitulo': 'Aprobar la divergencia de conjunto',
    'pendencias.aprovarMensagem': 'La composición de la carga {{carga}} queda aceptada como está, distinta del viaje de Protheus. Una diferencia nueva vuelve a aparecer.',
    'pendencias.corrigirEm.clientesHub': 'Clientes HUB',
    'pendencias.corrigirEm.utilitarios': 'Utilitarios',
    'pendencias.corrigirEm.hospedagem': 'Hospedaje',
    'pendencias.registro.linhaOutros': 'Línea de Otros Servicios',
    'pendencias.registro.maquinario': 'Línea de maquinaria',
    'pendencias.registro.contrato': 'Contrato',
    'pendencias.detalhe.hub': 'HUB',
    'pendencias.detalhe.protheus': 'Protheus',
    'pendencias.detalhe.semHospedagem_one': '{{count}} operador sin hospedaje',
    'pendencias.detalhe.semHospedagem_other': '{{count}} operadores sin hospedaje',
    'pendencias.detalhe.viagens': 'Viajes',
    'pendencias.detalhe.maquinarios': 'Maquinaria',
    'pendencias.detalhe.colheitas': 'Cosechas',
    'pendencias.detalhe.semServico': 'Sin servicio',
    'pendencias.campo.motorista': 'Conductor',
    'pendencias.campo.cavalo': 'Tractor',
    'pendencias.campo.carreta': 'Remolque',
    'pendencias.campo.cliente': 'Cliente sin Cliente HUB',
    'pendencias.campo.pedagio': 'Peaje',
    'pendencias.campo.hectares': 'Hectáreas',
    'pendencias.campo.data_inicio': 'Fecha de inicio',
    'pendencias.campo.data_fim': 'Fecha de fin',
    'pendencias.etapa.escalado': 'Escalado',
    'pendencias.etapa.carregando': 'Cargando',
    'pendencias.etapa.transito': 'En tránsito',
    'pendencias.etapa.descarregando': 'Descargando',
    'pendencias.etapa.atendido': 'Atendido',
    'pendencias.etapa.nao_atendido': 'No atendido',
  },
}
